


























import { ProjectManagement } from "@/data/models/Client";
import { getClientInfo, getProjectManagementType } from "@/data/repository/ClientRepository";
import { Component, Vue } from "vue-property-decorator";
import { getBuildDate, getRunningBuild } from "@/utils/BuildInfo";

@Component
export default class HelpComponent extends Vue {
  get versionString() {
    return this.$t("common.version", [getRunningBuild().version]).toString();
  }

  get buildString() {
    const build = getRunningBuild();

    return this.$t("common.build", [
      String(build.buildNumber),
      getBuildDate(build),
    ]).toString();
  }

  get projectAppVersionString() {
    return this.$t("common.projectAppVersion", [this.projectAppVersion]).toString();
  }

  get testAppVersionString() {
    return this.$t("common.testProjectAppVersion", [this.testProjectAppVersion]).toString();
  }

  get roomInfoConfigVersionString() {
    return this.$t("common.roomInfoConfigVersion", [this.roomInfoConfigVersion]).toString();
  }

  get testRoomInfoConfigVersionString() {
    return this.$t("common.testRoomInfoConfigVersion", [this.testRoomInfoConfigVersion]).toString();
  }

  get clientInfo() {
    return getClientInfo();
  }

  get showAppDetails() {
    const projectManagementType = getProjectManagementType();

    return (projectManagementType === ProjectManagement.PROJECT_OPTION ||
      projectManagementType === ProjectManagement.DEFAULT) && this.projectAppVersion;
  }

  get testClientMetadata() {
    return this.clientInfo?.testMetadata;
  }

  get showTestAppVersion() {
    return this.testProjectAppVersion && this.testProjectAppVersion !== this.projectAppVersion;
  }

  get showTestRoomInfoConfigVersion() {
    return this.testRoomInfoConfigVersion && this.testRoomInfoConfigVersion !== this.roomInfoConfigVersion;
  }

  get projectAppVersion() {
    if (!this.clientInfo?.targetAppVersion) {
      return 0;
    }

    return this.clientInfo.targetAppVersion;
  }

  get roomInfoConfigVersion() {
    if (!this.clientInfo?.targetRoomInfoConfigVersion) {
      return 0;
    }

    return this.clientInfo.targetRoomInfoConfigVersion;
  }

  get testProjectAppVersion() {
    if (!this.testClientMetadata?.appVersion) {
      return 0;
    }

    return this.extractAppVersion(this.testClientMetadata.appVersion);
  }

  get testRoomInfoConfigVersion() {
    if (!this.testClientMetadata?.roomInfoConfigVersion) {
      return 0;
    }

    return this.testClientMetadata.roomInfoConfigVersion;
  }

  extractAppVersion(appVersion: string) {
    const tokens = appVersion.split(".")[0].split("-");
    return parseInt(tokens[tokens.length - 1]) ?? 0;
  }
}
